/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  set.add(value);
  return set;
}

module.exports = addSetEntry;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_addSetEntry.js
 ** module id = 243
 ** module chunks = 0
 **/